/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import { Application } from '@hotwired/stimulus';
import { definitionsFromContext } from 'stimulus/webpack-helpers';

// it is officially supported option to load static assets if we not import them within the webpack manually
// ref: https://guides.rubyonrails.org/webpacker.html#using-webpacker-for-static-assets, https://rossta.net/blog/importing-images-with-webpacker.html
require.context('/frontend/app/assets/fonts', true);

const application = Application.start();
const context = require.context('../controllers', true, /\.js$/);
application.load(definitionsFromContext(context));

document.addEventListener('DOMContentLoaded', () => {
  // Below code fixes scroll restoration in navigation between V2 and V4.
  //
  // When any link with data-turbolinks="false" is clicked, it resets the
  // default V4 scroll position to 0. As expected, when web browser navigation
  // is used (next/back/reload), the scroll position is not being reset.
  //
  // Event delegation is used to ensure that the event handler is attached
  // to all links, even those that are added to the DOM after the initial load.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[data-turbolinks="false"]');

    if (link) {
      const routerScrollPositionsStorageKey = 'react-router-scroll-positions';
      const savedScrollPositions = JSON.parse(
        window.sessionStorage.getItem(routerScrollPositionsStorageKey) || '{}',
      );

      const pathname = new URL(link.href).pathname;

      if (pathname in savedScrollPositions) {
        window.sessionStorage.setItem(
          routerScrollPositionsStorageKey,
          JSON.stringify({ ...savedScrollPositions, [pathname]: 0 }),
        );
      }
    }
  });
});
